import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ButtonComponet from '../../detail/components/Button.component';

const LinkProductsList = ({ label, to, state, page, ...sx }) => {
  const userAuth = useSelector((state) => state.login?.user);
  return (
    <ButtonComponet
      variant='contained'
      {...sx}
      label={
        <Link
          to={to}
          state={state}
          style={{ textDecoration: 'none', color: '#fff' }}
        >
          {label}
        </Link>
      }
      disabled={userAuth?.permissions?.[page]?.PRODUCT_LIST === 'false'}
    />
  );
};

export default LinkProductsList;
